import Swiper, { Navigation, Pagination, A11y } from "swiper";
import "swiper/css";

$(function () {
  let sliders = [...document.querySelectorAll(".composition--slider")];
  sliders.forEach(slider => {
		const slides = [...slider.querySelectorAll(".grid-col")];
		// BELOW TESTS WHETHER SLIDES HAVE BEEN ADDED TO SLIDER CONFIGURATION
		if (slides.length > 0) {
			const container = slides[0].closest(".container");
			const wrapper = slides[0].closest(".row");
			const nextBtn = document.createElement("button");
			const prevBtn = document.createElement("button");
			const pagination = document.createElement("div");
			const skipLink = document.createElement("a");
			const postCarouselDiv = document.createElement("div");
			container.classList.add("swiper");
			wrapper.classList.add("swiper-wrapper");
			slides.forEach(s => s.classList.add("swiper-slide"));
			const randInt = (Math.ceil(Math.random() * 1000) + 1) * (Math.ceil(Math.random() * 1000) + 1) * (Math.ceil(Math.random() * 1000) + 1);
			skipLink.classList.add("swiper-skip-link");
			skipLink.textContent = "Skip this Carousel";
			skipLink.setAttribute("href", "#post-carousel-" + randInt);
			postCarouselDiv.classList.add("swiper-post");
			postCarouselDiv.setAttribute("id", "post-carousel-" + randInt);
			nextBtn.classList.add("swiper-button-next");
			prevBtn.classList.add("swiper-button-prev");
			pagination.classList.add("swiper-pagination");
			container.insertAdjacentElement("beforebegin", skipLink);
			container.insertAdjacentElement("beforebegin", prevBtn);
			container.insertAdjacentElement("beforebegin", nextBtn);
			container.insertAdjacentElement("afterend", postCarouselDiv);
			container.insertAdjacentElement("afterend", pagination);

			let config = {
				modules: [A11y, Navigation, Pagination],
				loop: false,
				a11y: true,
				navigation: {
					nextEl: nextBtn,
					prevEl: prevBtn,
				},
				pagination: {
					el: pagination,
					type: "bullets",
					clickable: true
				},
				sliderPerView: 1,
				spaceBetween: 18,
				breakpoints: {
					576: {
						slidesPerView: 2,
						spaceBetween: 30,
					},
					992: {
						slidesPerView: 3
					}
				}
			}
			const swiper = new Swiper(container, config);
		} else console.error("No slides added to slider configuration");
	});
});